// const productRegex = '(3d-model|stock-video|stock-animation|stock-music|stock-image|premiere-pro-template|after-effects-template|apple-motion-template|motion-graphics-template|davinci-resolve-template|davinci-resolve-macro|after-effects-plugins|sound-effect|lottie-animation)';

//  mediatype base regex
// const productRegex = '(3d-model|stock-video|stock-music|stock-image|premiere-pro-template|after-effects-template|apple-motion-template|motion-graphics-template|after-effects-plugins|sound-effect|lottie-animation)';
// const productSlashRegex = '(3d-model|stock-animation)';
// const productSlashRegex2 = '(davinci-resolve-template)';

// const routeConst = require('./const.js');

export default [
  // new "others" media types
  {
    path: '/:lang?/product/:id(\\d+)-:slug',
    name: 'product-others-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: null,
    },
  },

  {
    path: '/:lang?/(stock-video|stock-animation)([-/]):id(\\d+)([-/]):slug',
    name: 'product-video-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'video',
    },
  },
  {
    path: '/:lang?/(stock-music)([-/]):id(\\d+)([-/]):slug',
    name: 'product-music-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'music',
    },
  },
  {
    path: '/:lang?/(after-effects-template|after-effects-preset)([-/]):id(\\d+)([-/]):slug',
    name: 'product-ae-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'ae',
    },
  },
  {
    path: '/:lang?/(premiere-pro-template|premiere-pro-preset|motion-graphics-template)([-/]):id(\\d+)([-/]):slug',
    name: 'product-pr-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'pr',
    },
  },

  {
    path: '/:lang?/(apple-motion-template)([-/]):id(\\d+)([-/]):slug',
    name: 'product-fcp-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'fcp',
    },
  },
  {
    path: '/:lang?/(davinci-resolve-template|davinci-resolve-macro)([-/]):id(\\d+)([-/]):slug',
    name: 'product-resolve-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'resolve',
    },
  },
  {
    path: '/:lang?/(stock-image)([-/]):id(\\d+)([-/]):slug',
    name: 'product-image-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'image',
    },
  },
  {
    path: '/:lang?/(gif)([-/]):id(\\d+)([-/]):slug',
    name: 'product-gif-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'gif',
    },
  },
  {
    path: '/:lang?/(3d-model)([-/]):id(\\d+)([-/]):slug',
    name: 'product-3d-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: '3d',
    },
  },
  {
    path: '/:lang?/(sound-effect)([-/]):id(\\d+)([-/]):slug',
    name: 'product-sfx-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'sfx',
    },
  },
  {
    path: '/:lang?/(lottie-animation)([-/]):id(\\d+)([-/]):slug',
    name: 'product-lottie-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      // '@/views/product/ElementPageLoader.vue'),
      '@/views/product/ElementPageLoaderInfiniteScroll.vue'
    ),
    meta: {
      footer: 'disable',
      channel: 'lottie',
    },
  },
  // {
  //   path: `/:lang?/${productRegex}-:id(\\d+)([-/]):slug`,
  //   name: 'element-page',
  //   component: () => import(/* webpackChunkName: "product-page" */ '@/views/Product.vue'),
  //   meta: {
  //     layout: 'default',
  //
  //   },
  // },
  // {
  //   path: `/:lang?/${productRegex}/:id(\\d+)([-/]):slug`,
  //   name: 'element-page',
  //   component: () => import(/* webpackChunkName: "product-page" */ '@/views/Product.vue'),
  //   meta: {
  //     layout: 'default',
  //
  //   },
  // },
  {
    path: '/:lang?/c-:id(\\d+)-:slug',
    name: 'collection-page',
    component: () => import(
      /* webpackChunkName: "product-page" */
      /* webpackPrefetch: true */
      '@/views/product/CollectionPageLoader.vue'
    ),
    meta: {
      footer: 'disable',
      layout: 'default',
    },
  },
];
